import axios from 'axios';
import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  TOGGLE_COLLAPSED_NAV
} from 'constants/ActionTypes';
import { setLanguage, switchLanguage, setYearFilter, setCurrency, switchCurrency } from './Setting';
import { clearFileUploadToken } from '../utils/FileUploadAuth';
import { checkPasswordExpire, isPasswordExpired, showPasswordExpiredAlert } from '../utils/PasswordExpire';
import { isLicenseExpiredLoginError, showLicenseExpiredAlert } from '../utils/LicenseExpire';

export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: authUser
  }
};

export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};

export const resetToggleNav = () => {
  return {
    type: TOGGLE_COLLAPSED_NAV,
    isNavCollapsed: false
  };
}

export const userSignIn = (payload) => {
  const { username, password } = payload;
  const url = process.env.REACT_APP_API_URL + "auth/login";

  return (dispatch, getState) => {
    axios.post(url, { username, password }, { validateStatus: false })
      .then(async response => {
        if (response.data.user) {
          const token = response.data.token;
          const user = response.data.user;
          const config = response.data.config;
          const year = response.data.year;
          const language = response.data.language;
          const currency = response.data.currency;
          const calendarType = response.data.calendarType;
          const companyAPI = response.data.companyAPI;
          const ispApiURL = response.data.ispApiURL;

          //ตรวจสอบรหัสผ่านหมดอายุก่อนเก็บ session (ต้องรอ login สำเร็จเพราะ company มาจาก response)
          const passwordExpire = await checkPasswordExpire(user.Division, user.Username, token.accessToken);
          if (isPasswordExpired(passwordExpire)) {
            dispatch(hideAuthLoader());
            showPasswordExpiredAlert(user.Division, getState().i18n.translate, { accessToken: token.accessToken });
            return;
          }

          let GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
          let GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

          let MS_OUTLOOK_CLIENT_ID = "";
          let MS_OUTLOOK_TENANT_ID = "";

          //User
          const authUser = {
            id: user.Id,
            username: user.Username,
            name: user.Name,
            role: user.Role,
            company: user.Division,
            salesOrg: user.SalesOrg,
            channel: user.Channel,
            userType: user.UserType,
            salesman: user.Salesman,
            parentSalesman: user.ParentSalesman,
            imageProfile: user.ImageProfile,
            calendarType: user.CalendarType,
            calendarPlanTrip: user.CalendarPlanTrip ? user.CalendarPlanTrip : "Google",
            gmailAccount: user.GmailAccount,
            gCalendarId: user.GCalendarId,
            gCalendarName: user.GCalendarName,
            outlookAccount: user.OutlookAccount,
            outlookCalendarId: user.OutlookCalendarId,
            outlookCalendarName: user.OutlookCalendarName,
            config: config,
          };

          //Year for filter
          let yearList = year.map(y => {
            return {
              value: y.Year,
              label: y.Year
            }
          });

          //Language
          const languageDefault = {
            id: language.default.LangId,
            code: language.default.LangCode,
            name: language.default.LangName,
            icon: language.default.LangIconLocation,
          };
          const languageList = language.data.map(lang => {
            return {
              id: lang.LangId,
              code: lang.LangCode,
              name: lang.LangName,
              icon: lang.LangIconLocation,
            }
          });

          //Currency
          const currencyDefault = {
            code: currency.default.CurrencyCode,
            rate: currency.default.CurrencyRate,
          };

          const currencyList = currency.data.map(curr => {
            return {
              code: curr.CurrencyCode,
              rate: curr.CurrencyRate,
            }
          });

          //Company Key
          if (companyAPI && companyAPI.length > 0) {
            //Google Key
            const googleClientIdObj = companyAPI.find(item => item.APIProvider === "google" && item.APIProject === "ISB" && item.APIType === "OAuth2.0" && item.APIKeyType === "CLIENT_ID");
            const googleApiKeyObj = companyAPI.find(item => item.APIProvider === "google" && item.APIProject === "ISB" && item.APIType === "API_KEY" && item.APIKeyType === "KEY");

            if (googleClientIdObj)
              GOOGLE_CLIENT_ID = googleClientIdObj.APIKey;

            if (googleApiKeyObj)
              GOOGLE_API_KEY = googleApiKeyObj.APIKey;

            //MS Outlook Key
            const msOutlookClientIdObj = companyAPI.find(item => item.APIProvider === "microsoft" && item.APIProject === "ISB" && item.APIType === "OAuth2.0" && item.APIKeyType === "CLIENT_ID");
            const msOutlookTenantIdObj = companyAPI.find(item => item.APIProvider === "microsoft" && item.APIProject === "ISB" && item.APIType === "OAuth2.0" && item.APIKeyType === "TENANT_ID");

            if (msOutlookClientIdObj)
              MS_OUTLOOK_CLIENT_ID = msOutlookClientIdObj.APIKey;

            if (msOutlookTenantIdObj)
              MS_OUTLOOK_TENANT_ID = msOutlookTenantIdObj.APIKey;
          }

          localStorage.setItem("authUser", JSON.stringify(authUser));
          localStorage.setItem("yearList", JSON.stringify(yearList));
          localStorage.setItem("languageList", JSON.stringify(languageList));
          localStorage.setItem("languageSelected", JSON.stringify(languageDefault));
          localStorage.setItem("currencyList", JSON.stringify(currencyList));
          localStorage.setItem("currencySelected", JSON.stringify(currencyDefault));
          localStorage.setItem("gmailAccount", authUser.gmailAccount);
          localStorage.setItem("gCalendarId", authUser.gCalendarId);
          localStorage.setItem("gCalendarName", authUser.gCalendarName);
          localStorage.setItem('x-access-token', token.accessToken);
          //localStorage.setItem('x-access-token-expiration', Date.now() + 3600 * 1000); //Convert to millisecond (X * 1000)
          localStorage.setItem('x-access-token-expiration', Date.now() + token.expiresIn * 1000); //Convert to millisecond (X * 1000)
          localStorage.setItem('googleClientId', GOOGLE_CLIENT_ID);
          localStorage.setItem('googleApiKey', GOOGLE_API_KEY);
          localStorage.setItem("outlookAccount", authUser.outlookAccount);
          localStorage.setItem("outlookCalendarId", authUser.outlookCalendarId);
          localStorage.setItem("outlookCalendarName", authUser.outlookCalendarName);
          localStorage.setItem("msOutlookClientId", MS_OUTLOOK_CLIENT_ID);
          localStorage.setItem("msOutlookTenantId", MS_OUTLOOK_TENANT_ID);
          localStorage.setItem("ispApiURL", ispApiURL);

          // Check if MS Outlook keys were just set and reload if needed
          const needsReload = MS_OUTLOOK_CLIENT_ID && MS_OUTLOOK_TENANT_ID;

          dispatch(hideMessage());
          dispatch(userSignInSuccess(authUser));
          dispatch(setYearFilter(yearList));
          dispatch(setLanguage(languageList));
          dispatch(switchLanguage(languageDefault));
          dispatch(setCurrency(currencyList));
          dispatch(switchCurrency(currencyDefault))
          dispatch(resetToggleNav());

          // Reload page after login to reinitialize MSAL with correct config
          if (needsReload) {
            setTimeout(() => {
              window.location.reload();
            }, 500); // Small delay to ensure state is updated
          }
        } else if (isLicenseExpiredLoginError(response)) {
          //License ของบริษัทหมดอายุ — isb-api ไม่ออก token (403 LICENSE_EXPIRED)
          dispatch(hideMessage());
          showLicenseExpiredAlert(getState().i18n.translate);
        } else {
          dispatch(showAuthMessage(response.data.message));
        }
      })
      .catch(error => {
        dispatch(showAuthMessage(error.response));
      })
  }
}

export const userSignOut = () => {
  return dispatch => {
    localStorage.removeItem("authUser");
    localStorage.removeItem("yearList");
    localStorage.removeItem("languageList");
    localStorage.removeItem("languageSelected");
    localStorage.removeItem("currencyList");
    localStorage.removeItem("currencySelected");
    localStorage.removeItem("gmailAccount");
    localStorage.removeItem("gCalendarId");
    localStorage.removeItem("gCalendarName");
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("x-access-token-expiration");
    localStorage.removeItem("googleClientId");
    localStorage.removeItem("googleApiKey");
    localStorage.removeItem("outlookAccount");
    localStorage.removeItem("outlookCalendarId");
    localStorage.removeItem("outlookCalendarName");
    localStorage.removeItem("msOutlookClientId");
    localStorage.removeItem("msOutlookTenantId");

    //token ของ file-manage เก็บไว้ใน memory ไม่ได้อยู่ใน localStorage ต้องล้างแยก
    clearFileUploadToken();

    dispatch(userSignOutSuccess());
  }
};
